export const cilVolumeHigh = ["24 24","<path d='M6.814 5.625h-6.064v12.75h6.064l4.875 4.875h1.811v-22.5h-1.811zM6 16.875h-3.75v-9.75h3.75zM12 21.439l-4.5-4.5v-9.878l4.5-4.5z'></path><path d='M19.125 12c-0.003-2.277-1.848-4.122-4.125-4.125h-0v1.5c1.45 0 2.625 1.175 2.625 2.625s-1.175 2.625-2.625 2.625v0 1.5c2.277-0.003 4.122-1.848 4.125-4.125v-0z'></path><path d='M15 2.693v1.513c3.811 0.548 6.75 3.834 6.75 7.794s-2.939 7.247-6.75 7.794v1.513c4.641-0.557 8.25-4.518 8.25-9.307s-3.609-8.75-8.25-9.307z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-volume-high.js
// module id = null
// module chunks = 